import Cookies from 'js-cookie';

export const AD_OPTOUT_COOKIE_NAME = 'gd_ads_optout';

const cookieAttributes = () => {
  // Only set `secure` when the page is served over HTTPS. On http://localhost
  // the browser silently drops Secure cookies, which would make the opt-out
  // appear broken in dev.
  const isSecure =
    typeof window !== 'undefined' && window.location.protocol === 'https:';
  return {
    expires: 365,
    sameSite: 'lax' as const,
    path: '/',
    secure: isSecure
  };
};

export function isGPCEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  // `globalPrivacyControl` is not in lib.dom yet — cast through unknown.
  return (
    (window.navigator as unknown as { globalPrivacyControl?: boolean })
      .globalPrivacyControl === true
  );
}

export function isAdTrackingOptedOut(): boolean {
  if (isGPCEnabled()) return true;
  return Cookies.get(AD_OPTOUT_COOKIE_NAME) === 'true';
}

export function setAdTrackingOptOut(value: boolean): void {
  if (value) {
    Cookies.set(AD_OPTOUT_COOKIE_NAME, 'true', cookieAttributes());
  } else {
    // Match path so removal lines up with how it was set.
    Cookies.remove(AD_OPTOUT_COOKIE_NAME, { path: '/' });
  }
}
